import React, { useEffect, useState } from 'react';
import "../../styles/TrustedBy.css";
import { getTrustedBy } from '../../api/contentApi';

const BRAND_SYMBOLS = {
  youtube: '▶',
  google: 'G',
  meta: '∞',
  canva: 'C',
  adobe: '▲',
  hubspot: '●',
  instagram: '◎',
  linkedin: 'in',
};

function BrandIcon({ icon }) {
  switch (icon) {
    case 'google':
      return (
        <span className="google-brand-mark" aria-hidden="true">
          <span className="g-blue">G</span>
          <span className="g-red">o</span>
          <span className="g-yellow">o</span>
          <span className="g-blue">g</span>
          <span className="g-green">l</span>
          <span className="g-red">e</span>
        </span>
      );
    case 'instagram':
      return (
        <span className="insta-brand-gradient-wrapper" aria-hidden="true">
          <span className="insta-brand-glyph">
            <span className="insta-lens-ring" />
            <span className="insta-sensor-dot" />
          </span>
        </span>
      );
    case 'linkedin':
      return <span className="linkedin-brand-mark">in</span>;
    case 'adobe':
      return <span className="adobe-icon" aria-hidden="true">▲</span>;
    case 'hubspot':
      return <span className="hubspot-icon" aria-hidden="true">●</span>;
    case 'youtube':
      return <span className="logo-icon color-yt">{BRAND_SYMBOLS[icon]}</span>;
    case 'meta':
      return <span className="logo-icon color-meta">{BRAND_SYMBOLS[icon]}</span>;
    default:
      return <span className={`logo-icon color-${icon}`}>{BRAND_SYMBOLS[icon] || '•'}</span>;
  }
}

export default function TrustedBy() {
  const [trustedContent, setTrustedContent] = useState([]);

  useEffect(() => {
    getTrustedBy()
      .then((items) => setTrustedContent(Array.isArray(items) ? items : []))
      .catch((error) => console.error('Unable to load trusted platforms:', error));
  }, []);

  const sectionTitle = trustedContent[0]?.title || 'Trusted By Creators From';

  return (
    <section className="trusted-by-section">
      <div className="trusted-container-box">
        
        {/* Floating Top Anchor Badge */}
        <div className="trusted-floating-badge">
          {sectionTitle}
        </div>

        {/* Brand Logos Row Container */}
        <div className="trusted-logos-flex-row">
          
          {trustedContent.filter((item) => item.brand).map((item) => {
            const icon = String(item.icon || '').toLowerCase();
            return (
              <div className={`brand-logo-item font-${icon}`} key={item.id}>
                <BrandIcon icon={icon} />
                <span className="logo-text">{item.brand}</span>
              </div>
            );
          })}

        </div>

      </div>
    </section>
  );
}